import { get, post, put, destroy } from "presentation/utils/api";

//Define a rota base desse serviço
const baseRoute = "Students";


export const findAll = async () => {
    return await get(baseRoute);
};

export const findById = async (id) => {
    return await get(baseRoute, "/" + id);
};

export const add = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "create", data);
};

export const update = async (postData) => {
    var data = JSON.stringify(postData);
    return await put(baseRoute, "update", data);
};

export const save = async (postData) => {
    if (postData.id !== undefined) {
        return await update(postData);
    } else {
        return await add(postData);
    }
};

export const remove = async (id) => {
    return await destroy(baseRoute, "full_delete", id);
};

export const getNextRegistration = async () => {
    return await get(baseRoute, "nextRegistration");
};

export const search = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "search", data);
};

export const saveUser = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "saveUser", data);
};

const studentsService = {
    findAll,
    findById,
    add,
    update,
    save,
    remove,
    getNextRegistration,
    search,
    saveUser
}

export default studentsService;